import { useQuery } from "react-query";
import { connect } from "react-redux";

import { UPDATE_FILTERS, fetchDimensions } from "common/actions/email";
import { FilterBarRedux } from "common/components/filterBar/FilterBar";

const mapStateToProps = (state) => ({
    qualifiers: state.emails.qualifiers
});

const mapDispatchToProps = {
    updateFilters: UPDATE_FILTERS
};

export const EmailFilterBar = connect(mapStateToProps, mapDispatchToProps)(({
    qualifiers,
    updateFilters
}) => {
    const { data: dimensions } = useQuery("emails.dimensions", fetchDimensions);

    if (!dimensions) {
        return null;
    }

    return (
        <FilterBarRedux
            qualifiers={qualifiers}
            sourcesOverride={dimensions}
            categoryModeAvailable={false}
            onChange={updateFilters}
        />
    );
});
